import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export const RevealOnScroll = ({ children }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  const childWithProps =
    typeof children === "object" && children.type
      ? { ...children, props: { ...children.props, inView } }
      : children;

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {childWithProps}
    </motion.div>
  );
};
